import {
  PrimaryDialog,
  WarningCustomIcon,
  StyledButton,
} from "react-common-ui-library";
import { useIntl } from "react-intl";
import { Typography } from "@mui/material";
import {
  CANNOT_CONFIRM_ACCOUNT_TITLE,
  CANNOT_CONFIRM_ACCOUNT_OK_BTN,
  CANNOT_CONFIRM_ACCOUNT_CONTENT,
  CANNOT_CONFIRM_ACCOUNT_MODAL,
} from "../../../Constants/VerifyAccountConstants";
import {
  CONTAINED,
  H2,
  H3,
  CONTACT_US_PAGE,
  CONTACT_NUMBER,
} from "../../../Constants/CommonConstants";
import PropTypes from "prop-types";
import ConfigService from "../../../Services/ConfigService";

const contactNumber = ConfigService(CONTACT_NUMBER);

/**
 * @description The modal that is displayed when the OTP validation limit gets exhausted or user's account is locked due to maximum attempts reached for login.
 * @param {boolean} open Boolean flag to show the modal
 * @param {function} setCannotConfirmModalIsOpen Setter method to update the boolean flag
 * @returns {ReactNode} Renders the modal to the user
 */
export const CannotConfirmAccountModal = (props) => {
  const intl = useIntl();

  const { open, setCannotConfirmModalIsOpen } = props;

  const okButtonClickHandler = () => {
    setCannotConfirmModalIsOpen(false);
    window.location.href = CONTACT_US_PAGE;
  };

  return (
    <PrimaryDialog
      id={CANNOT_CONFIRM_ACCOUNT_MODAL}
      title={intl.formatMessage({ id: CANNOT_CONFIRM_ACCOUNT_TITLE })}
      titleIcon={<WarningCustomIcon />}
      open={open}
      actions={
        <StyledButton
          id={CANNOT_CONFIRM_ACCOUNT_OK_BTN}
          variant={CONTAINED}
          onClick={okButtonClickHandler}
        >
          {intl.formatMessage({ id: CANNOT_CONFIRM_ACCOUNT_OK_BTN })}
        </StyledButton>
      }
    >
      <Typography
        id={CANNOT_CONFIRM_ACCOUNT_CONTENT}
        component={H2}
        variant={H3}
      >
        {intl.formatMessage(
          { id: CANNOT_CONFIRM_ACCOUNT_CONTENT },
          { contactNumber: contactNumber }
        )}
      </Typography>
    </PrimaryDialog>
  );
};

CannotConfirmAccountModal.propTypes = {
  /**
   * Displays cannot confirm account modal when open is set to true
   */
  open: PropTypes.bool.isRequired,
  /**
   * Function to set modal open
   */
  setCannotConfirmModalIsOpen: PropTypes.func.isRequired,
};
